import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import CustomerList from "./Component/CustomerList";
import SubscriptionAdd from "./Component/SubscriptionAdd";
import ConfirmOrderCMP from "./Component/ConfirmOrderCMP";

const useStyles3 = makeStyles(javascriptStyles);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const ConfirmOrder = ({ selectedDialogData }) => {
	const classes3 = useStyles3();
	const classesCSStyles = useStylesCustomerDetailsStyles();

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		return function cleanup() {};
	}, []);

	return (
		<div className={classNames(classes3.py5)}>
			<div className={classNames("flex")}>
				{/* <div className={classNames(classesCSStyles.leftSide)}>
					<CustomerList />
				</div> */}
				<div className={classNames(classesCSStyles.rightSide)}>
					<ConfirmOrderCMP />
				</div>
			</div>
		</div>
	);
};

export default ConfirmOrder;
